@if (!data.withoutIcon) {
  @switch (data.type) {
    @case ('success') {
      <mat-icon class="icon mr-3" data-test-id="success-icon">check_circle</mat-icon>
    }
    @case ('information') {
      <mat-icon class="icon mr-3" data-test-id="info-icon">info</mat-icon>
    }
    @case ('error') {
      <mat-icon class="icon mr-3" data-test-id="error-icon">error</mat-icon>
    }
  }
}

<div class="msg-wrapper">
  <span class="msg" data-test-id="message">{{
    data.translate ? (data.msg | transloco: data.translateKeys) : data.msg
  }}</span>
  @if (data.requestId) {
    <span class="request-id" data-test-id="request-id">[id: {{ data.requestId }}]</span>
  }
</div>

<button
  type="button"
  [title]="'close' | transloco"
  class="d-block close-icon pl-2"
  [inlineSVG]="'/icons/no-stroke-icon-close.svg'"
  (click)="close()"
  data-test-id="close-button"
></button>
